import React from 'react';

interface TableCellProps {
  variant?: 'common' | 'warning' | 'danger' | 'extreme';
  children?: any;
}

const TableCell = ({ variant, children }: TableCellProps) => (
  <td
    style={{
      background: {
        common: 'transparent',
        warning: 'limegreen',
        danger: 'var(--bs-warning)',
        extreme: 'tomato',
      }[variant!],
    }}
  >
    {children}
  </td>
);

TableCell.defaultProps = {
  variant: 'common',
  children: null,
};

export default TableCell;
